module.exports = __webpack_public_path__ + "img/icon_reg_16.3b46831c.png";